/**
 * Pobiera offset strefy czasowej użytkownika w minutach.
 * Offset jest ujemny dla stref na wschód od UTC (np. UTC+1 = -60),
 * i dodatni dla stref na zachód od UTC (np. UTC-5 = 300).
 *
 * @returns Offset w minutach (np. -60 dla UTC+1, 120 dla UTC-2)
 */
export const getTimezoneOffset = (): number => {
  if (typeof window === "undefined") {
    return 0;
  }

  // getTimezoneOffset() zwraca offset w minutach, ale z przeciwnym znakiem
  // np. dla UTC+1 zwraca -60, dla UTC-5 zwraca 300
  // My chcemy: UTC+1 = -60, UTC-5 = 300 (tak jak zwraca getTimezoneOffset)
  return new Date().getTimezoneOffset();
};